import { render } from "./AcelerometroView.vue?vue&type=template&id=54e3f91d"
import script from "./AcelerometroView.vue?vue&type=script&lang=js"
export * from "./AcelerometroView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__